import { twJoin } from 'tailwind-merge';

import { ArrowUpIcon } from '@/core/tamagoshiTailwind/icons/ArrowUpIcon';
import { footerToTopButtonAriaLabel } from '@/domains/retention/Footer/translations';

import styles from './ToTopButton.module.scss';

export const ToTopButton = () => (
  <button
    aria-label={footerToTopButtonAriaLabel}
    className={twJoin(
      styles.activeContainer,
      `focus:cursor-pointer" absolute bottom-l right-l flex h-[48px] w-[48px]
      items-center justify-center rounded-full border border-foundation-inverted
      bg-transparent text-foundation-inverted hover:cursor-pointer
      active:cursor-pointer desktop:right-0`,
    )}
    type="button"
    onClick={() => {
      window.scrollTo(0, 0);
    }}
  >
    <ArrowUpIcon className={'size-[30px]'} />
  </button>
);

ToTopButton.displayName = 'ToTopButton';
